import React      from 'react';
import CSSModules from 'react-css-modules';

import style from './style.scss';

class TermsAndConditions extends React.Component {

    render() {

        return (
            <div>

                <div styleName="terms-box">

                    <p>
                        On receipt of a booking form an acknowledgement email will be either automatically generated or sent from one of the training team. Joining instructions will be emailed to delegates 7 to 10 days before a course. If these have not been received 3 working days before the relevant course, please contact us to ensure your place has been booked, as we cannot be held responsible for non-arrival of registration instructions. Invoices and/or VAT receipts will be issued in due course.
                    </p>

                    <p>
                        All bookings must be confirmed with a purchase order number or the appropriate remittance within 15 working days of booking in order to secure the place. If no confirmation, purchase order number or appropriate remittance is provided, places will be released for resale.
                    </p>

                    <p>
                        For assistance please email <a href="mailto:training@rheglobal.com">training@rheglobal.com</a> or call 01239 711793.
                    </p>

                    <p>
                        In the event that you need to cancel your booking, a refund will only be provided if written notification is received at least 15 working days before the relevant course date. No refunds will be made for delegate withdrawals notified after this date.
                    </p>

                    <p>
                        RH Environmental Ltd reserves the right to cancel or amend any course at its absolute discretion. Delegates will be notified in advance and provided with the option to transfer to another event or a full refund or the appropriate portion thereof. However, RH Environmental Ltd shall not be liable to the delegate, or the party making the booking, where different, for any damage, consequential loss, cost, expense or the like and howsoever arising.
                    </p>

                    <p>
                        In the case of emergencies, RH Environmental Ltd reserves the right to replace the advertised speakers with suitable substitutes.
                    </p>

                    <p>
                        The views expressed at the courses are personal to the speakers and are not attributable to RH Environmental Ltd, which accepts no responsibility for them. Delegates are recommended to take specific independent advice.
                    </p>

                    <p>
                        Delegates attending site visits do so at their own risk and must have suitable insurance in place to cover this activity.
                    </p>

                    <p>
                        We may use your personal data, to provide you with marketing information about our services. We may also notify you about third party services. If we contact you with marketing information, it will be through email, post or telephone. You can ask us to stop sending you marketing information at anytime by contacting info@rheglobal.com or clicking unsubscribe on electronic mail you receive from us.
                    </p>

                    <p>
                        Please see our full <a target="_blank" href={`${window.config['tos_licence_link']}`}>Terms of Service</a> for more information.
                    </p>

                </div>

            </div>
        );
    }
}

export default CSSModules(TermsAndConditions, style);


// WEBPACK FOOTER //
// ./components/TermsAndConditions/index.js